// extracted by mini-css-extract-plugin
module.exports = {"root":"searchBar_root__3IAjR","input_group":"searchBar_input_group__r6zvQ","input":"searchBar_input__1Ytr9"};